import { ShieldAlert } from "lucide-react";
import { useTranslate } from "ra-core";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";

/**
 * Rendered by ra-core on `/authentication-error` when the auth provider
 * cannot verify the session (e.g. the API is unreachable).
 */
export const AuthenticationError = () => {
  const translate = useTranslate();
  return (
    <div className="flex flex-col items-center gap-4 py-16 text-center">
      <ShieldAlert className="h-10 w-10 text-muted-foreground" />
      <h1 className="text-2xl font-semibold">
        {translate("ra.page.authentication_error")}
      </h1>
      <p className="text-muted-foreground">
        {translate("ra.message.authentication_error")}
      </p>
      <Button asChild variant="outline">
        <Link to="/login">{translate("ra.auth.sign_in")}</Link>
      </Button>
    </div>
  );
};
